import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as pastProductsFromSomeoneElseState from '../employee-detail.reducer';
import * as pastProductsFromSomeoneElseReducer from '../reducers/past-products-from-someone-else.reducer';

export const getPastProductsFromSomeoneElse = createSelector(
  pastProductsFromSomeoneElseState.getPastProductsFromSomeoneElseState,
  pastProductsFromSomeoneElseReducer.getPastProductsFromSomeoneElseResponse
);
